import { networkManager } from './NetworkManager';

interface ApiResponse<T> {
  status: boolean;
  data: T;
}

interface TokenData {
  id_token: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
}

interface UserProfile {
  sub: string;
  email?: string;
  username?: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  groups: string[];
  roles: string[];
  capabilities: string[];
}

/**
 * Exchange authorization code for tokens.
 */
export async function exchangeToken(code: string, redirectUri: string): Promise<TokenData> {
  const response = await networkManager.post<ApiResponse<TokenData>>('/api/auth/token', {
    code,
    redirect_uri: redirectUri,
  });
  return response.data;
}

/**
 * Refresh tokens using refresh token.
 */
export async function refreshToken(refreshTokenValue: string): Promise<TokenData> {
  const response = await networkManager.post<ApiResponse<TokenData>>('/api/auth/refresh', {
    refresh_token: refreshTokenValue,
  });
  return response.data;
}

/**
 * Get current user profile from JWT.
 */
export async function getCurrentUser(): Promise<UserProfile> {
  const response = await networkManager.get<ApiResponse<UserProfile>>('/api/auth/me');
  return response.data;
}

/**
 * Health check.
 */
export async function healthCheck(): Promise<{ service: string; version: string; uptime: number }> {
  const response =
    await networkManager.get<ApiResponse<{ service: string; version: string; uptime: number }>>(
      '/api/health',
    );
  return response.data;
}
